"use strict";Object.defineProperty(exports, "__esModule", {value: true});









var BlobjectFilter; (function (BlobjectFilter) {
  const COMPLETED = "COMPLETED"; BlobjectFilter["COMPLETED"] = COMPLETED;
  const ACTIVE = "ACTIVE"; BlobjectFilter["ACTIVE"] = ACTIVE;
})(BlobjectFilter || (exports.BlobjectFilter = BlobjectFilter = {}));

// The inbox tabs. Filtered on the server; All sends the unfiltered request.
var InboxTab; (function (InboxTab) {
  const ALL = "ALL"; InboxTab["ALL"] = ALL;
  const UNREAD = "UNREAD"; InboxTab["UNREAD"] = UNREAD;
  // Chats with an open request the caller sees (GetInbox's RequestsOnly),
  // newest request first. KEYWORDS orgs only; its count comes from the open
  // requests (shared/selectors/requests), not GetInboxCounts.
  const REQUESTS = "REQUESTS"; InboxTab["REQUESTS"] = REQUESTS;
  const PATIENTS = "PATIENTS"; InboxTab["PATIENTS"] = PATIENTS;
  const TEAM = "TEAM"; InboxTab["TEAM"] = TEAM;
  // Chats with a pending scheduled message you can see (GetInbox's
  // ScheduledOnly). Mobile shows it only when there is one.
  const SCHEDULED = "SCHEDULED"; InboxTab["SCHEDULED"] = SCHEDULED;
})(InboxTab || (exports.InboxTab = InboxTab = {}));
